// Polyfill para evitar erro "Cannot redefine property: backgroundColor"
// Este arquivo deve ser importado antes do Chart.js

const originalDefineProperty = Object.defineProperty;

Object.defineProperty = function(obj, prop, descriptor) {
  // Verificar se a propriedade já existe e se é "backgroundColor"
  if (prop === 'backgroundColor' && obj && obj.hasOwnProperty && obj.hasOwnProperty(prop)) {
    try {
      const existingDescriptor = Object.getOwnPropertyDescriptor(obj, prop);
      if (existingDescriptor && !existingDescriptor.configurable) {
        // Se a propriedade já existe e não é configurável, simplesmente ignore
        console.warn(`Tentativa de redefinir propriedade não configurável: ${prop}`);
        return obj;
      }
    } catch (error) {
      console.warn(`Erro ao verificar propriedade ${prop}:`, error);
    }
  }
  
  try {
    return originalDefineProperty.call(this, obj, prop, descriptor);
  } catch (error) {
    if (error.message.includes('Cannot redefine property')) {
      console.warn(`Redefinição da propriedade ${prop} ignorada:`, error.message);
      return obj;
    }
    throw error;
  }
};

const polyfill = {};
export default polyfill;
